import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import * as moment from 'moment';
import {IBarcode} from '../domain/accounts/IBarcode';

@Injectable({
  providedIn: 'root'
})
export class BarcodeService {

  constructor(private http: HttpClient) {
  }
  createBarcode(barcode: IBarcode) {
    return this.http.post(`/accounts/barcodes`, barcode);
  }

  getBarcodes(loadType?: string, startDate?: Date, endDate ?: Date) {
    const now = moment();
    const requestStartDate = startDate == null ? moment(`${now.format('YYYYMM')}01`, 'YYYYMMDD') : moment(startDate);
    const requestEndDate = endDate == null ? now : moment(endDate);
    return this.http.get(`/accounts/barcodes?startDate=${requestStartDate.format('YYYY-MM-DD')}&endDate=${requestEndDate.format(`YYYY-MM-DD`)}&loadType=${loadType}`);
  }

}
